import React, { Component } from "react";
import { find } from "lodash";
import DesignTool from "../../designtool";

export default class FortuneList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fortuneList: [],
      colorList: [
        "#FE80B0",
        "#A273FC",
        "#9399FF",
        "#57B7B5",
        "#F88020",
        "#F5C600"
      ]
    };
  }

  componentDidMount() {
    let _this = this;

    // Update percent fortune list
    DesignTool.on("onchange", function() {
      let { productList } = _this.props;
      let { fortuneList } = _this.state;
      let items = DesignTool.getItems();
      let rodeoType = 5;
      let charmType = 6;

      for (var i = 0; i < fortuneList.length; i++) {
        let fortuneName = fortuneList[i].name;
        let allItemPercent = 0;
        let allItems = 0;

        if (!fortuneList[i].percent) {
          fortuneList[i].percent = 0;
        }

        for (var j = 0; j < items.length; j++) {
          let item = find(productList, function(cir) {
            return cir.id === items[j].productID;
          });

          if (item !== undefined) {
            if (rodeoType !== item.type && charmType !== item.type) {
              let itemFortunes = item.fortunes;
              let it = find(itemFortunes, function(t) {
                return t.name === fortuneName;
              });
              if (it !== undefined) {
                allItemPercent += it.percent;
              }
              allItems++;
            }
          }
        }
        fortuneList[i].percent = Math.round(allItemPercent / allItems);
      }

      _this.setState({
        fortuneList: fortuneList
      });
    });
  }

  componentDidUpdate(prevProps) {
    let { isSaveSuccess, handleUpdateState, fortuneList } = this.props;

    if (prevProps.fortuneList !== fortuneList) {
      this.setState({
        fortuneList: fortuneList
      });
    }

    // Reset fortune list
    if (isSaveSuccess) {
      let tmpFortuneList = [...this.state.fortuneList];
      tmpFortuneList.map(item => (item.percent = 0));

      this.setState({ fortuneList: tmpFortuneList });
      handleUpdateState("isSaveSuccess", false);
    }
  }

  render() {
    let { fortuneList, colorList } = this.state;

    return (
      <div className="fortune_wrap">
        <ul>
          {fortuneList.map((item, index) => (
            <li key={index} style={{ backgroundColor: colorList[index] }}>
              <span>{item.name}</span>
              <span>{item.percent || 0}%</span>
            </li>
          ))}
        </ul>
      </div>
    );
  }
}
